
      const customCSSPropertiesMap = {
        "maxContentWidth": "--awsui-max-content-width-lqnbqg",
"minContentWidth": "--awsui-min-content-width-lqnbqg",
"breadcrumbsGap": "--awsui-breadcrumbs-gap-lqnbqg",
"contentGapLeft": "--awsui-content-gap-left-lqnbqg",
"contentGapRight": "--awsui-content-gap-right-lqnbqg",
"contentHeight": "--awsui-content-height-lqnbqg",
"contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-lqnbqg",
"contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-lqnbqg",
"contentLayoutMainGap": "--awsui-content-layout-main-gap-lqnbqg",
"defaultMaxContentWidth": "--awsui-default-max-content-width-lqnbqg",
"defaultMinContentWidth": "--awsui-default-min-content-width-lqnbqg",
"drawerSize": "--awsui-drawer-size-lqnbqg",
"drawerMinSize": "--awsui-drawer-min-size-lqnbqg",
"bottomDrawerSize": "--awsui-bottom-drawer-size-lqnbqg",
"footerHeight": "--awsui-footer-height-lqnbqg",
"headerGap": "--awsui-header-gap-lqnbqg",
"headerHeight": "--awsui-header-height-lqnbqg",
"layoutWidth": "--awsui-layout-width-lqnbqg",
"mainGap": "--awsui-main-gap-lqnbqg",
"mainOffsetLeft": "--awsui-main-offset-left-lqnbqg",
"mainTemplateRows": "--awsui-main-template-rows-lqnbqg",
"mobileBarHeight": "--awsui-mobile-bar-height-lqnbqg",
"notificationsHeight": "--awsui-notifications-height-lqnbqg",
"offsetTop": "--awsui-offset-top-lqnbqg",
"overlapHeight": "--awsui-overlap-height-lqnbqg",
"navigationWidth": "--awsui-navigation-width-lqnbqg",
"splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-lqnbqg",
"splitPanelReportedSize": "--awsui-split-panel-reported-size-lqnbqg",
"splitPanelHeight": "--awsui-split-panel-height-lqnbqg",
"splitPanelMinWidth": "--awsui-split-panel-min-width-lqnbqg",
"splitPanelMaxWidth": "--awsui-split-panel-max-width-lqnbqg",
"toolsMaxWidth": "--awsui-tools-max-width-lqnbqg",
"toolsWidth": "--awsui-tools-width-lqnbqg",
"toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-lqnbqg",
"contentScrollMargin": "--awsui-content-scroll-margin-lqnbqg",
"flashbarStackDepth": "--awsui-flashbar-stack-depth-lqnbqg",
"flashbarStackIndex": "--awsui-flashbar-stack-index-lqnbqg",
"flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-lqnbqg",
"stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-lqnbqg",
"stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-lqnbqg",
"dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-lqnbqg",
"spinnerRotatorFrom": "--awsui-spinner-rotator-from-lqnbqg",
"spinnerRotatorTo": "--awsui-spinner-rotator-to-lqnbqg",
"spinnerLineLeftFrom": "--awsui-spinner-line-left-from-lqnbqg",
"spinnerLineLeftTo": "--awsui-spinner-line-left-to-lqnbqg",
"spinnerLineRightFrom": "--awsui-spinner-line-right-from-lqnbqg",
"spinnerLineRightTo": "--awsui-spinner-line-right-to-lqnbqg",
"sliderLabelCount": "--awsui-slider-label-count-lqnbqg",
"sliderTickCount": "--awsui-slider-tick-count-lqnbqg",
"sliderReferenceColumn": "--awsui-slider-reference-column-lqnbqg",
"sliderNextReferenceColumn": "--awsui-slider-next-reference-column-lqnbqg",
"sliderMaxStart": "--awsui-slider-max-start-lqnbqg",
"sliderMinEnd": "--awsui-slider-min-end-lqnbqg",
"sliderRangeInlineSize": "--awsui-slider-range-inline-size-lqnbqg",
"sliderTooltipPosition": "--awsui-slider-tooltip-position-lqnbqg",
"togglesLeftWidth": "--awsui-toggles-left-width-lqnbqg",
"togglesRightWidth": "--awsui-toggles-right-width-lqnbqg",
"promptInputMaxRows": "--awsui-prompt-input-max-rows-lqnbqg",
"promptInputScrollHeight": "--awsui-prompt-input-scroll-height-lqnbqg",
"dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-lqnbqg",
"dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-lqnbqg",
"styleBackgroundActive": "--awsui-style-background-active-lqnbqg",
"styleBackgroundDefault": "--awsui-style-background-default-lqnbqg",
"styleBackgroundDisabled": "--awsui-style-background-disabled-lqnbqg",
"styleBackgroundHover": "--awsui-style-background-hover-lqnbqg",
"styleBorderColorActive": "--awsui-style-border-color-active-lqnbqg",
"styleBorderColorDefault": "--awsui-style-border-color-default-lqnbqg",
"styleBorderColorDisabled": "--awsui-style-border-color-disabled-lqnbqg",
"styleBorderColorHover": "--awsui-style-border-color-hover-lqnbqg",
"styleColorActive": "--awsui-style-color-active-lqnbqg",
"styleColorDefault": "--awsui-style-color-default-lqnbqg",
"styleColorDisabled": "--awsui-style-color-disabled-lqnbqg",
"styleColorHover": "--awsui-style-color-hover-lqnbqg",
"styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-lqnbqg",
"styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-lqnbqg",
"styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-lqnbqg",
"styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-lqnbqg",
"styleBoxShadowActive": "--awsui-style-box-shadow-active-lqnbqg",
"styleBoxShadowDefault": "--awsui-style-box-shadow-default-lqnbqg",
"styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-lqnbqg",
"styleBoxShadowHover": "--awsui-style-box-shadow-hover-lqnbqg",
"alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-lqnbqg",
"alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-lqnbqg",
"alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-lqnbqg",
"alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-lqnbqg",
"alertIconColor": "--awsui-alert-icon-color-lqnbqg",
      };
      export default customCSSPropertiesMap;
    